var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"number-chart"},[(_vm.dataSource.length === 0)?[_vm._v("暂无数据")]:[_vm._v(" "+_vm._s(_vm.dataSource.join('，'))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }